import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import { BodyCopy, Subtitle } from 'components/ui/Typography'

import s from './Credits.module.scss'
const cn = classNames.bind(s)

const Credit = ({ name, role }) => (
  <li className={cn('item')}>
    <div className={cn('role')}>
      <Subtitle>{role}</Subtitle>
    </div>
    <div className={cn('name')}>
      <BodyCopy semiBold>{name}</BodyCopy>
    </div>
  </li>
)

Credit.propTypes = {
  name: PropTypes.string,
  role: PropTypes.string,
}

export default Credit
